import { PromotionApplyOnEnum } from '@teko/types/ecommerce';
import { t } from '../i18n.es.js';

const convertStatusToProductTag = (status) => {
  switch (status == null ? void 0 : status.sellingCode) {
    case "hang_trung_bay":
      return { content: t("H\xE0ng tr\u01B0ng b\xE0y"), variant: "default" };
    case "hang_dat_truoc":
      return { content: t("H\xE0ng \u0111\u1EB7t tr\u01B0\u1EDBc"), variant: "default" };
    case "ngung_kinh_doanh":
      return { content: t("Ng\u1EEBng kinh doanh"), variant: "default" };
    case "hang_khac":
      return { content: t("H\xE0ng qu\xE0 t\u1EB7ng"), variant: "default" };
    default:
      return void 0;
  }
};
const convertProductCard = (product) => {
  var _a, _b;
  const {
    productInfo,
    promotions,
    totalAvailable,
    prices,
    flashSales,
    status
  } = product;
  let hasGift = false;
  promotions.forEach((el) => {
    var _a2;
    if (el.applyOn === PromotionApplyOnEnum.product && (((_a2 = el == null ? void 0 : el.benefit) == null ? void 0 : _a2.gifts) || []).length)
      hasGift = true;
  });
  const productPrice = prices == null ? void 0 : prices[0];
  let flashSale;
  let isFlashSale = false;
  const flSale = flashSales[0];
  if (flashSales.length) {
    isFlashSale = true;
    flashSale = {
      endAt: new Date(parseInt(flSale.endTimestampSec) * 1e3),
      text: flSale.totalCount - flSale.usedCount > 0 ? t("C\xF2n l\u1EA1i {{var0}}", {
        var0: flSale.totalCount - flSale.usedCount
      }) : t("Ch\xE1y h\xE0ng"),
      discountPercent: Math.round(productPrice.discountPercent)
    };
  }
  let titleTag = null;
  const isOutOfStock = product.totalAvailable === 0;
  if (isOutOfStock) {
    titleTag = {
      variant: "link",
      content: t("Li\xEAn h\u1EC7 \u0111\u1EB7t h\xE0ng")
    };
  } else if (!(productPrice == null ? void 0 : productPrice.latestPrice)) {
    titleTag = {
      variant: "pending",
      content: t("Li\xEAn h\u1EC7")
    };
  }
  const infoTags = [];
  if (status && convertStatusToProductTag(status)) {
    infoTags.push(convertStatusToProductTag(status));
  }
  const stockQuantity = totalAvailable === null ? 1e3 : isFlashSale ? Math.min(flSale.totalCount - flSale.usedCount, totalAvailable) : totalAvailable;
  return {
    sku: productInfo.sku,
    name: productInfo.name,
    imageUrl: productInfo.imageUrl,
    price: productPrice ? {
      latestPrice: +productPrice.latestPrice,
      supplierRetailPrice: productPrice.discountPercent ? +productPrice.supplierRetailPrice : 0,
      discountPercent: productPrice.discountPercent && !isFlashSale ? `-${productPrice.discountPercent}%` : void 0,
      discountAmount: +productPrice.discountAmount > 0 && !isFlashSale ? +productPrice.discountAmount : void 0
    } : { supplierRetailPrice: 0, latestPrice: 0 },
    stockQuantity,
    stockQuantityText: !isFlashSale && !isOutOfStock && stockQuantity < 5 ? t("C\xF2n {{stockQuantity}} s\u1EA3n ph\u1EA9m", { stockQuantity }) : void 0,
    warranty: {
      months: (_b = (_a = productInfo.warranty) == null ? void 0 : _a.months) != null ? _b : 0
    },
    flashSale,
    hasGift,
    titleTag: titleTag || void 0,
    infoTags: infoTags || void 0
  };
};

export { convertProductCard };
